import React from 'react';
import './ChartLegend.css';

const ChartLegend = ({ legendData, darkMode }) => {
    if (!legendData) return null;

    const themeClass = darkMode ? 'dark' : 'light';

    return (
        <div className={`ntc-chart-legend ${themeClass}`}>
            <span className="ntc-legend-label">O</span>
            <span className={`ntc-legend-value ${legendData.direction}`}>
                {legendData.open?.toFixed(5)}
            </span>
            <span className="ntc-legend-label high">H</span>
            <span className="ntc-legend-value high">
                {legendData.high?.toFixed(5)}
            </span>
            <span className="ntc-legend-label low">L</span>
            <span className="ntc-legend-value low">
                {legendData.low?.toFixed(5)}
            </span>
            <span className="ntc-legend-label">C</span>
            <span className={`ntc-legend-value ${legendData.direction}`}>
                {legendData.close?.toFixed(5)}
            </span>
        </div>
    );
};

export default ChartLegend;
